module.exports = __webpack_public_path__ + "static/media/ENVIRONMENT - Cool grey 1C.b3579a98.jpg";